export const HeaderData = [
  {
    label: "Cases",
    href: "/cases",
  },
];
